export default "__VITE_ASSET__D2vORFV3__"